// extracted by mini-css-extract-plugin
export var Spinner = "Spinner-module--Spinner--MfCcV";
export var fade = "Spinner-module--fade--RPfrn";
export var rotate = "Spinner-module--rotate--pH9Eg";